import Loading from 'components/common/loading/Loading'
import { Chat as ChatType } from 'components/types'
import { useState } from 'react'

import { i18n } from '../../i18n'
import Modal from '../common/modal/Modal'
import Chat from './Chat'
import Chats from './Chats'

interface MessagesModalProps {
  isOpen: boolean
  isLoading: boolean
  messages: ChatType[]
  handleClose: () => void
}

const MessagesModal = ({
  isOpen,
  isLoading,
  messages,
  handleClose,
}: MessagesModalProps) => {
  const [selectedChat, setSelectedChat] = useState<ChatType | null>(null)
  const [newMessage, setNewMessage] = useState<string>('')

  const handleSendMessage = () => {
    if (selectedChat && newMessage.trim()) {
      // const updatedChat = {
      //   ...selectedChat,
      //   messages: [
      //     ...selectedChat.messages,
      //     {
      //       id: selectedChat.messages.length + 1,
      //       text: newMessage,
      //       sender: 'person1',
      //     },
      //   ],
      // }
      // setSelectedChat(updatedChat)
      // const updatedChats = chats.map(chat =>
      //   chat.id === selectedChat.id ? { ...updatedChat, lastMessage: newMessage } : chat
      // )

      setNewMessage('')
    }
  }

  if (isLoading) return <Loading />

  return (
    <Modal
      icon="regular-comment"
      isOpen={isOpen}
      onClose={handleClose}
      title={i18n.translate('messagesTitle')}
    >
      <div className="flex h-full">
        <Chats
          chats={messages}
          selectedChat={selectedChat}
          handleSelect={setSelectedChat}
        />
        <Chat
          selectedChat={selectedChat}
          newMessage={newMessage}
          handleSendMessage={handleSendMessage}
          setNewMessage={setNewMessage}
        />
      </div>
    </Modal>
  )
}

export default MessagesModal
